import React from 'react';
const paths={
 users:'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M22 21v-2a4 4 0 0 0-3-3.87M15 3.13a4 4 0 0 1 0 7.75',
 companies:'M3 21h18M5 21V3h14v18M9 7h1M14 7h1M9 11h1M14 11h1M10 21v-6h4v6',
 suppliers:'M3 21V7l6 3V7l6 3V3h6v18H3M7 15h2M13 15h2M17 15h2',
 consignees:'M12 22s8-7 8-13A8 8 0 0 0 4 9c0 6 8 13 8 13',
 invoices:'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6v6h6M8 13h8M8 17h6',
 purchaser:'M12 16V3M7 8l5-5 5 5M3 16v4a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-4',
 nearest:'M3 6h18v15H3V6M7 3v6M17 3v6M3 11h18M7 15h3',
 payments:'M3 5h18v14H3V5M3 9h18M15 15h3',
 dashboard:'M3 20h18M6 16V9M12 16V4M18 16v-5',
 reports:'M4 3h16v18H4V3M8 7h8M8 11h8M8 15h5',
 general:'M3 3h7v7H3V3M14 3h7v7h-7V3M3 14h7v7H3v-7M14 14h7v7h-7v-7',
 personal:'M3 20v-5l6-4 5 3 7-9M16 5h5v5',
 automations:'M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1',
 collapse:'M3 4h18v16H3V4M9 4v16M16 9l-3 3 3 3',
 menu:'M4 6h16M4 12h16M4 18h16',
 context:'M4 7h15l-3-3M20 17H5l3 3',
 logout:'M9 4H4v16h5M9 12h12M17 8l4 4-4 4',
};
export default function WorkspaceIcon({name}){return <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d={paths[name]||paths.invoices}/>{name==='users'&&<circle cx="9" cy="7" r="4"/>}{name==='consignees'&&<circle cx="12" cy="9" r="2.5"/>}{name==='automations'&&<circle cx="12" cy="12" r="5"/>}</svg>;}
